import { Component } from "modules/Component";

import "./breadcrumbs.scss";

export class Breadcrumbs extends Component<typeof Breadcrumbs> {
    static readonly className: string = "js-breadcrumbs-component";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        const overflowIcon = rootElement.querySelector<HTMLSpanElement>(".js-has-overflow");
        const overflowing = this.isOverflowing();

        if (overflowing && overflowIcon) {
            overflowIcon.style.display = "flex";
            this.removeOverflowingListItems(rootElement);
        }
    }

    private removeOverflowingListItems(rootElement: HTMLSpanElement) {
        const listItems = rootElement.querySelectorAll<HTMLLIElement>(".js-breadcrumbs-list li");

        for (let i = 0; i < listItems.length - 1; i++) {
            if (this.isOverflowing()) {
                listItems[i].remove();
            }
        }
    }

    private isOverflowing() {
        const list = this.rootElement.querySelector<HTMLOListElement>(".js-breadcrumbs-list");
        const overflowIcon = this.rootElement.querySelector<HTMLSpanElement>(".js-has-overflow");

        return list && overflowIcon && list.scrollWidth > (this.rootElement.offsetWidth - overflowIcon.offsetWidth);
    }

}